import {
  ArtTile,
  CountUp,
  formatInt,
  formatMinutes,
  formatPercent,
  formatTimes,
} from '../index.js';

import type { StyleWithVars } from '../index.js';
import type { PartyWrapped } from '@mixwire/contracts';
import type { ReactElement } from 'react';

type Slide09CrowdProps = {
  readonly wrapped: PartyWrapped;
};

const MULTIPLICATION_SIGN = '×';

export const Slide09Crowd = ({ wrapped }: Slide09CrowdProps): ReactElement => {
  const { crowd, tokenCount } = wrapped;
  const { mostWanted } = crowd;

  const phonesStyle: StyleWithVars = { '--d': '200' };
  const wantsStyle: StyleWithVars = { '--d': '350' };
  const cardStyle: StyleWithVars = { '--d': '900' };
  const stampStyle: StyleWithVars = { '--d': '1500' };
  const closingStyle: StyleWithVars = { '--d': '1700' };

  return (
    <>
      <p className="lede rise">Meanwhile, on the request page</p>

      <div className="pair">
        <div className="stat rise" style={phonesStyle}>
          <strong>
            <CountUp to={tokenCount} format={formatInt} />
          </strong>
          <span>phones signed in</span>
        </div>
        <div className="stat rise" style={wantsStyle}>
          <strong>
            <CountUp to={crowd.wants} format={formatInt} />
          </strong>
          <span>requests sent</span>
        </div>
      </div>

      {mostWanted === null ? null : (
        <div className="wanted pop" style={cardStyle}>
          <ArtTile album={mostWanted.title} artUrl={mostWanted.artUrl} label={mostWanted.title} />
          <div className="wanted-text">
            <p className="small">Most requested</p>
            <b>{mostWanted.title}</b>
            <p>{mostWanted.artist}</p>
          </div>
          <span className="wanted-stamp stamp" style={stampStyle}>
            {MULTIPLICATION_SIGN}
            {formatInt(mostWanted.wants)}
          </span>
        </div>
      )}

      {crowd.wants === 0 ? (
        <p className="lede rise" style={closingStyle}>
          Nobody sent a request in — the night was the DJs&rsquo; own.
        </p>
      ) : (
        <p className="lede rise" style={closingStyle}>
          {mostWanted === null ? 'Overall, ' : `Played ${formatTimes(mostWanted.plays)}. Overall, `}
          <b>
            <CountUp to={crowd.playedFraction} format={formatPercent} delayMs={1900} />
          </b>{' '}
          of requests got played, on average{' '}
          <b>
            <CountUp to={crowd.avgWaitMs} format={formatMinutes} delayMs={1900} />
          </b>{' '}
          minutes after being sent.
        </p>
      )}
    </>
  );
};
